/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Checkbox, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Vocabulary } from "../../Utils/Vocabulary";
import { CloudUpload } from "@mui/icons-material";
import DropzoneComponent from "./DropzoneComponent";
import styles from "../../Styles/showImages.module.css";
import { useEffect, useState } from "react";
import theme from "../../Themes/Theme";
import axios from "axios";

type AddAndShowImagesProps = {
  images: Array<any>;
  files: any;
  maxFiles?: number;
  checkedImages?: any;
  isSmall?: boolean;
  handleDeleteImages: (
    newImageList: any,
    newFileList: any,
    index: number
  ) => void;
  handleChangeFiles: (files: any) => void;
  displayDropzoneImages: (images: any) => void;
  handleCheckImages?: (index: number) => void;
};

export default function AddAndShowImages(props: AddAndShowImagesProps) {
  const {
    images,
    files,
    maxFiles,
    checkedImages,
    isSmall,
    handleDeleteImages,
    handleChangeFiles,
    displayDropzoneImages,
    handleCheckImages,
  } = props;
  const [showDropzone, setShowDropzone] = useState<boolean>(false);
  const [dropzoneFiles, setDropzoneFiles] = useState<any>([]);
  const [imageData, setImageData] = useState<any>([]);
  const [shouldUpdate, setShouldUpdate] = useState(true);
  /**
   *
   * @param files
   */
  function handleChangeDropFile(files: any) {
    if (files.length !== 0) {
      handleChangeFiles(files);
      const images = [] as any;
      files.forEach((file: any) => {
        const reader = new FileReader();
        if (file.type.match("image.*")) {
          reader.readAsDataURL(file);
          reader.onloadend = function () {
            setImageData((prev: any[]) => [
              ...prev,
              {
                path: reader.result,
                name: file.name,
              },
            ]);
            setDropzoneFiles(images);
          };
        }
      });
    }
  }
  /**
   *
   * @param index
   */
  function deleteImage(index: any) {
    const imageToDelete = imageData[index];
    const newImageList = imageData.slice() as any;
    let newFileList = [];

    // If it's an external URL, just remove it from the array
    // No need to search for it in local files
    if (imageToDelete?.isExternalUrl) {
      setImageData((prev: any[]) => prev.filter((_, i) => i !== index));
      newImageList.splice(index, 1);
      handleDeleteImages(newImageList, files, index);
    } else {
      // Handle local files as before
      if (files) {
        setImageData((prev: ImageData[]) => prev.filter((_, i) => i !== index));
        newFileList = files.slice() as any;
        const fileIndex = newFileList.findIndex(
          (file: any) => file.name === newImageList[index].name
        );
        if (fileIndex >= 0) newFileList.splice(fileIndex, 1);
      }
      newImageList.splice(index, 1);
      handleDeleteImages(newImageList, newFileList, index);
    }
  }

  const token = localStorage.getItem("access_token");
  let axiosConfig = {} as any;
  if (token) {
    axiosConfig = {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
        "cache-control": "no-cache",
      },
    };
  }

  /**
   * Check if a string is a web URL
   */
  function isWebUrl(str: string): boolean {
    return str.startsWith("http://") || str.startsWith("https://");
  }

  useEffect(() => {
    if (images.length > 0 && shouldUpdate) {
      images.map(async (image) => {
        // If the image is already a web URL, use it directly
        if (isWebUrl(image)) {
          setImageData((prev: any[]) => [
            ...prev,
            {
              path: image,
              name: image.split("/").pop() || "image",
              isExternalUrl: true,
            },
          ]);
        } else {
          // Fetch the image from the backend
          try {
            const img = await axios.get(image, axiosConfig);
            const url = URL.createObjectURL(img.data);
            setImageData((prev: any[]) => [
              ...prev,
              {
                path: url,
                name: img.data?.name,
                isExternalUrl: false,
              },
            ]);
          } catch (error) {
            console.error("Error fetching image:", error);
          }
        }
        setShouldUpdate(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images]);
  /**
   *
   */
  function showImages() {
    displayDropzoneImages([...images, ...dropzoneFiles]);
    setDropzoneFiles([]);
    setShowDropzone(false);
  }
  return (
    <>
      {showDropzone ? (
        <div style={{ marginTop: 20 }}>
          <DropzoneComponent
            onSave={(files: any) => handleChangeDropFile(files)}
            maxFiles={maxFiles}
          />
          <Button
            variant="contained"
            size="large"
            className={styles.showImagesBtn}
            onClick={showImages}
            style={{ color: "white" }}
          >
            {Vocabulary.finish}
          </Button>
        </div>
      ) : (
        <>
          <Button
            variant="contained"
            size="medium"
            style={{ marginTop: 20, marginBottom: 10, color: "white" }}
            onClick={() => setShowDropzone(true)}
          >
            <CloudUpload
              fontSize="medium"
              style={{
                marginRight: 10,
              }}
            />
            {Vocabulary.attachFiles}
          </Button>
          <div>
            <div className={styles.displayImagesContainer}>
              {imageData.map((image: any, index: any) => {
                return (
                  <div
                    key={`image_${index}`}
                    className={
                      isSmall ? styles.displayImagesSmall : styles.displayImages
                    }
                  >
                    {handleCheckImages && handleCheckImages ? (
                      <Checkbox
                        checked={checkedImages.includes(index) ? true : false}
                        onChange={() => handleCheckImages(index)}
                        className={styles.checkboxImagesBtn}
                        style={{ color: theme.palette.primary.main }}
                      />
                    ) : null}
                    <IconButton
                      className={styles.deleteImagesBtn}
                      onClick={() => deleteImage(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                    <img
                      src={image.path}
                      alt="preview"
                      style={{ height: "100%" }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </>
  );
}
